<div
  class="{{ colorClass[color] || 'text-textPrimary' }} flex flex-col text-sm"
  [class.gap-2]="label"
>
  <label for="{{ id }}"> {{ label }}</label>
  <p-calendar
    *ngIf="control && !view"
    ariaLabel="{{ label }}"
    [formControl]="control"
    [iconDisplay]="'input'"
    [placeholder]="placeholder"
    [numberOfMonths]="selectionMode == 'range' ? 2 : 1"
    [showIcon]="true"
    inputId="{{ id }}"
    [selectionMode]="selectionMode === 'range' ? 'range' : 'single'"
    inputStyleClass="w-full {{ colorClass[color] }} {{
      !dense ? 'py-4' : 'py-2'
    }} rounded-lg text-textPrimary"
    styleClass="flex"
    (onSelect)="onSelect($event)"
  >
    <ng-template pTemplate="inputicon" let-clickCallBack="clickCallBack">
      <i
        class="pi pi-calendar pointer-events-none"
        (click)="clickCallBack($event)"
      ></i>
    </ng-template>
  </p-calendar>

  <p-calendar
    *ngIf="!control"
    ariaLabel="{{ label }}"
    [iconDisplay]="'input'"
    [showIcon]="true"
    inputId="{{ id }}"
    [selectionMode]="selectionMode === 'range' ? 'range' : 'single'"
    inputStyleClass="{{ colorClass[color] }} {{
      !dense ? 'py-4' : 'py-2'
    }} rounded-lg text-textPrimary"
    styleClass="grid"
    (onSelect)="onSelect($event)"
  >
    <ng-template pTemplate="inputicon" let-clickCallBack="clickCallBack">
      <i
        class="pi pi-calendar pointer-events-none absolute top-1/2 mt-[-0.5rem]"
        (click)="clickCallBack($event)"
      ></i>
    </ng-template>
  </p-calendar>

  <p-calendar
    *ngIf="control && view"
    ariaLabel="{{ label }}"
    [formControl]="control"
    [iconDisplay]="'input'"
    [showIcon]="true"
    [view]="view"
    dateFormat="{{ dateFormat }}"
    inputId="{{ id }}"
    [readonlyInput]="true"
    [selectionMode]="selectionMode === 'range' ? 'range' : 'single'"
    inputStyleClass="w-full {{ colorClass[color] }} {{
      !dense ? 'py-4' : 'py-2'
    }} rounded-lg text-textPrimary"
    styleClass="flex"
    (onSelect)="onSelect($event)"
  >
    <ng-template pTemplate="inputicon" let-clickCallBack="clickCallBack">
      <i
        class="pi pi-calendar pointer-events-none absolute top-1/2 mt-[-0.5rem]"
        (click)="clickCallBack($event)"
      ></i>
    </ng-template>
  </p-calendar>

  <small *ngIf="helperText" class="colorClass[color] || 'text-textPrimary'">{{
    helperText
  }}</small>
</div>
